import type { FC } from 'react';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components/macro';

/** Card height ~72px at mobile, ~80px at tablet, ~88px at 992px+. Gap 6–8px. */
const CARD_HEIGHT = 80;
const GAP = 8;

const TicketsCardViewLoader: FC = () => {
  const theme = useTheme();

  return (
    <ContentLoader
      data-testid="tickets-cards-loading"
      speed={2}
      width="100%"
      height="100vh"
      backgroundColor={theme.colors.surface}
      foregroundColor={theme.colors.primary.variant6}
    >
      {/* Single column: mobile & tablet */}
      <rect x="0" y="0" rx="6" ry="6" width="100%" height={CARD_HEIGHT} />
      <rect x="0" y={CARD_HEIGHT + GAP} rx="6" ry="6" width="100%" height={CARD_HEIGHT} />
      <rect x="0" y={(CARD_HEIGHT + GAP) * 2} rx="6" ry="6" width="100%" height={CARD_HEIGHT} />
      <rect x="0" y={(CARD_HEIGHT + GAP) * 3} rx="6" ry="6" width="100%" height={CARD_HEIGHT} />
      <rect x="0" y={(CARD_HEIGHT + GAP) * 4} rx="6" ry="6" width="100%" height={CARD_HEIGHT} />
      <rect x="0" y={(CARD_HEIGHT + GAP) * 5} rx="6" ry="6" width="100%" height={CARD_HEIGHT} />
      <rect x="0" y={(CARD_HEIGHT + GAP) * 6} rx="6" ry="6" width="100%" height={CARD_HEIGHT} />
      <rect x="0" y={(CARD_HEIGHT + GAP) * 7} rx="6" ry="6" width="100%" height={CARD_HEIGHT} />
      <rect x="0" y={(CARD_HEIGHT + GAP) * 8} rx="6" ry="6" width="100%" height={CARD_HEIGHT} />
      <rect x="0" y={(CARD_HEIGHT + GAP) * 9} rx="6" ry="6" width="100%" height={CARD_HEIGHT} />
    </ContentLoader>
  );
};

export default TicketsCardViewLoader;
